import * as APPCONFIG from "../config/app-config.js";
import auth from "./AuthAPI.js";
import Http from "./Http.js";


export const saveCreditCard = (form) => {

    return auth({
     method: "post",
    url: `${APPCONFIG.API_URL}api/credit-cards/save`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });

};


export const getCreditCard = async () => {
  const res = await auth({
    method: "get",
    url: `${APPCONFIG.API_URL}api/credit-cards/getByUser`,
    headers: Http.AUTH_HEADERS(),
  });
  // Always return array
  return Array.isArray(res.data?.data) ? res.data.data : [];
};


export const deleteCreditCard = (cardId) => {
  return auth({
    method: "delete",
    url: `${APPCONFIG.API_URL}api/credit-cards/delete/${cardId}`,
    headers: Http.AUTH_HEADERS(), // JWT included for authentication
  });
};




